import React from 'react';
import './TopicBlock.scss';
import htbSteps from '../../constants/htb-steps.constant';
import partners from '../../constants/partners.constant';
import { Row, Col, Container } from 'react-bootstrap';
import { Icon, Button } from '../ui/index';
// @ts-ignore
import Carousel from 'react-grid-carousel';

const TopicBlock = () => {
  return (
    <div className="topic-block">
      <div className="topic-block-body">
        <HowToBuyBlock />
        <UpdateBlocks />
        <div className="partners-block">
          <h2 className="uppercase">Our Partners</h2>
          <PartnerBlocks />
        </div>
      </div>
    </div>
  );
}

const HowToBuyBlock = () => {
  return (
    <div className="how-to-buy-block">
      <h2>How to buy with VisionHub?</h2>
      <h3>Easy. <span className="pink">Fast.</span> Anywhere. <span className="pink">Anytime.</span></h3>
      <Container fluid className="steps">
        <Row>
        {htbSteps.map((step, index)=> (
          <Col sm={6} md={6} lg={3} key={index} className="justify-content-center">
              <Icon imgPath={step.imagePath} />
              <h4>{step.label}</h4>
              <h5>{step.description}</h5>
          </Col>
        ))}
        </Row>
      </Container>
      <Button>Discover</Button>
    </div>
  )
}

const UpdateBlocks = () => {
  return (
    <Row className="updates">
      <Col sm={12} md={6} lg={6}>
        <Icon className="img-fluid" imgPath='/images/updates/spring-summer-collection.jpg' />
        <div className="overlay default">
          <h3>New collection</h3>
          <h2>Spring-summer</h2>
          <Button className="button default-button">COMING SOON</Button>
        </div>
      </Col>
      <Col sm={12} md={6} lg={6}>
        <Icon className="img-fluid" imgPath='/images/updates/lens-making-process.jpg' />
        <div className="overlay">
          <h3 className="light">Process of making</h3>
          <h2 className="typeA">Lens manufacture</h2>
          <Button className="button default-button">COMING SOON</Button>
        </div>
      </Col>
    </Row>
  )
}


const responsive = [
  {
    breakpoint: 900,
    cols: 3,
    rows: 1,
    gap: 10,
    loop: true,
    autoplay: 4000
  },
  {
    breakpoint: 750,
    cols: 1,
    rows: 1,
    gap: 10,
    loop: true,
    autoplay: 4000
  }
];

const PartnerBlocks = () => {
  return (
    <Carousel cols={4} rows={1} gap={10} loop showDots={true} autoplay={4000} responsiveLayout={responsive} containerClassName="carousel-partners">
      { 
        partners.map((partner, index) => (
          <Carousel.Item>
            <div className="item-partners">
              <a href={partner.urlPath} target="_blank">
                <Icon imgPath={partner.imagePath} className="item-partners-images" />
              </a>
            </div>
          </Carousel.Item>
        ))
      }
    </Carousel>
  )
}

export default TopicBlock;
